//Setup newsletter popup, check for varoius validations.
let confirmedUrl = 'customer_posted=true';
let validationUrl = 'challenge#contact_form';
let alreadyCustomerUrl = 'newsletter&form_type=customer'

let closeNewsletterPopUp = document.getElementById('closeNewsletter');
let newsletterPopUpContainer = document.getElementById("newsletterPopUp");
let newsletterPopUpOverlay = document.getElementById('newsletterPopUpOverlay');
let newsletterContent = document.getElementById('newsletterContent');

function checkNewsletterCookie() {
  var newsletter = getCookie("newsletter-popup");
  var newsletterPopUp = document.getElementById("newsletterPopUp");

  if (window.location.href.indexOf(validationUrl) != -1){
    newsletterPopUpContainer.classList.remove('open');
    newsletterPopUpOverlay.classList.remove('open');
  } else if (window.location.href.indexOf(alreadyCustomerUrl) != -1){
    newsletterPopUp.classList.add("open");
    newsletterPopUpOverlay.classList.add('open');
    newsletterContent.innerHTML = '<h3>You already have an account with us.</h3>';
  } else if (window.location.href.indexOf(confirmedUrl) != -1){
    newsletterPopUp.classList.add("open");
    newsletterPopUpOverlay.classList.add('open');
    newsletterContent.innerHTML = ' <div class="newsletter-popup__title">'+ '<h3 class="underline">Thank you!</h3>' + '<p>You have subscribed to our mailing list. Please check your email for confirmation.</p>' + '</div>';
  } else {
    if (newsletter == '') {
      function showIt() {
        newsletterPopUp.classList.add("open");
        newsletterPopUpOverlay.classList.add('open');
      }
      setTimeout(showIt, 5000);
    } else {
      console.log('no newsletter');
    }
  }
}

closeNewsletterPopUp.addEventListener('click', function(){
  newsletterPopUpContainer.classList.remove('open');
  newsletterPopUpOverlay.classList.remove('open');
}, false);

document.addEventListener("DOMContentLoaded", function(event) {  
  checkNewsletterCookie();
});